import { render, staticRenderFns } from "./EditConfiguration.vue?vue&type=template&id=4cf8b2be&scoped=true"
import script from "./EditConfiguration.vue?vue&type=script&lang=js"
export * from "./EditConfiguration.vue?vue&type=script&lang=js"
import style0 from "./EditConfiguration.vue?vue&type=style&index=0&id=4cf8b2be&prod&lang=css"
import style1 from "./EditConfiguration.vue?vue&type=style&index=1&id=4cf8b2be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf8b2be",
  null
  
)

export default component.exports